import { Controller } from "@hotwired/stimulus"

// Keeps the operator's claim on a newsletter's editor alive
// (Newsletters::EditingsController). Beats at once — a Save draft round trip
// may have released the claim on the way out — then every 30 s, well inside
// the server's 90 s expiry. When a colleague has taken over (409, or an
// autosave refused as "taken_over"), the form goes inert and the notice says who.
export default class extends Controller {
  static targets = ["notice", "editor", "content"]
  static values = {
    url: String,
    interval: { type: Number, default: 30000 }
  }

  connect() {
    this.lost = false
    this.onTakenOver = (event) => this.#lose(event.detail?.editor)
    document.addEventListener("editing-claim:taken-over", this.onTakenOver)
    this.beat()
    this.timer = setInterval(() => this.beat(), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
    document.removeEventListener("editing-claim:taken-over", this.onTakenOver)
    if (!this.lost) this.#release()
  }

  async beat() {
    if (this.lost) return
    try {
      const response = await fetch(this.urlValue, { method: "PATCH", headers: this.#headers() })
      if (response.status === 409) {
        const payload = await response.json().catch(() => ({}))
        this.#lose(payload.editor)
      }
    } catch (_error) {
      // Offline for a moment: the next beat tries again.
    }
  }

  #lose(editor) {
    if (this.lost) return
    this.lost = true
    clearInterval(this.timer)
    if (editor && this.hasEditorTarget) this.editorTarget.textContent = editor
    if (this.hasContentTarget) {
      this.contentTarget.inert = true
      this.contentTarget.classList.add("opacity-50")
    }
    if (this.hasNoticeTarget) {
      this.noticeTarget.hidden = false
      this.noticeTarget.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }

  // keepalive lets the request outlive the page it was sent from.
  #release() {
    fetch(this.urlValue, { method: "DELETE", headers: this.#headers(), keepalive: true }).catch(() => {})
  }

  #headers() {
    return {
      "Accept": "application/json",
      "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content,
      "X-Requested-With": "XMLHttpRequest"
    }
  }
}
